import { assetUrl as appAssetUrl, localUrl as appLocalUrl } from '../app-path.js';
import common from './common';

const user = {
	controlLoggedMenu: () => {
		$(document).on('click', '.act-control-logged-menu', function (e) {
			e.preventDefault();
			$('[data-modal=user-logged-menu]').toggleClass('_none');
		});
	},

	controlFavoritesLocalesBreadcrumb: () => {
		$(document).on(
			'click',
			'.act-control-favorites-locales-breadcrumb',
			function (e) {
				e.preventDefault();
				$('[data-id=list-favorites-locales-breadcrumb]').toggleClass('-active');
			},
		);
	},

	renderWeatherNowByFavoritesLocalesBreadcrumb: () => {
		const url = appLocalUrl(`/json/myclimatempo/user/weatherNowByFavoritesLocales?${Math.random(1, 1000)}`);
		const xhttp = new XMLHttpRequest();

		xhttp.onreadystatechange = function () {
			if (this.readyState !== 4) return;
			if (this.status !== 200) return;

			const responseText = (this.responseText || '').trim();
			if (!responseText || responseText[0] === '<') return;

			let response;
			try {
				response = JSON.parse(responseText);
			} catch (error) {
				return;
			}

			if (!Array.isArray(response)) return;

			response.forEach(item => {
				const weatherData = item?.data?.[0];
				const locale = weatherData?.locale;
				const weather = weatherData?.weather?.[0];
				if (!locale || !weather) return;

				const slug = common.createSlug(locale.name);
				const acronym = locale.acronym === 'BR' ? locale.uf : locale.acronym;
				const url = `${locale.city}/${slug}-${acronym.toLowerCase()}`;
				const cityName = `${locale.name}, ${acronym}`;

				const itemHtml = `
            <li class="item">
              <img class="icon" src="${appAssetUrl(`/dist/images/v2/svg/outline/${weather.icon}.svg`)}" width="20" height="20" alt="Ícone de temperatura atual">
              <a href="${appLocalUrl(`/previsao-do-tempo/cidade/${url}`)}" class="-white">
                ${cityName} / ${weather.temperature}&deg;
              </a>
            </li>
          `;

				$('[data-id=list-favorites-locales-breadcrumb]')
					.append(itemHtml)
					.removeClass('_none');
				$('[data-id=list-favorites-locales-arrow]').removeClass('_none');
			});
		};

		xhttp.open('GET', url, true);
		xhttp.send();
	},
};

export default user;
